import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import { ListActions, PageListProps } from "@saleor/types";
import { FilterPageProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { MerchantSettlement_merchantSettlement_edges_node } from "../../types/MerchantSettlement";
import MerchantSettlementList from "../MerchantSettlementList";
import {
  createFilterStructure,
  MerchantSettlementFilterKeys,
  MerchantSettlementListFilterOpts
} from "./filter";

export interface MerchantSettlementListPageProp
  extends PageListProps,
    ListActions,
    FilterPageProps<
      MerchantSettlementFilterKeys,
      MerchantSettlementListFilterOpts
    >,
    // SortPage<CustomerListUrlSortField>,
    TabPageProps {
  toggleAll: any;
  settlements: MerchantSettlement_merchantSettlement_edges_node[];
  hasSelected?: boolean;
}

const MerchantSettlementListPage: React.FC<MerchantSettlementListPageProp> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onAdd,
  onAll,
  onFilterChange,
  onSearchChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  ...listProps
}) => {
  const { user } = useUser();
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts, user.userType.code);

  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.merchantSettlement)}>
        <Button
          color="primary"
          variant="contained"
          onClick={listProps.download}
          disabled={!listProps.hasSelected}
        >
          Download
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: " "
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <MerchantSettlementList {...listProps} />
      </Card>
    </Container>
  );
};

export default MerchantSettlementListPage;
